// This Client should be used for communicating with Simplic's AWS API Gateway with JWT
import axios from 'axios';
import Cookies from 'js-cookie';
import tagRecordings from '../../tracking/hotjar/tagRecordings';
import captureSentryException from '../../tracking/sentry/captureSentryException';
import callToRefreshToken from './callToRefreshToken';

const cookieName = process.env.ACCESS_TOKENS_COOKIE_NAME;

function getAuthorization() {
  if (Cookies.get(cookieName)) {
    const unencoded = atob(Cookies.get(cookieName));
    const parsed = JSON.parse(unencoded);
    return parsed.access_token;
  }

  return '';
}

const ApiClient = axios.create();

window.axiosActive = 0;
ApiClient.interceptors.request.use((config) => {
  const newConfig = {
    ...config,
    headers: {
      Authorization: `Bearer ${getAuthorization()}`,
    },
  };
  window.axiosActive += 1;
  return newConfig;
});

ApiClient.interceptors.response.use((response) => {
  window.axiosActive -= 1;
  return response;
}, async (error) => {
  const errorResponse = error.response;
  if (!errorResponse) {
    captureSentryException(error);
    tagRecordings(['axios_error', 'unknown axios error']);
    window.axiosActive -= 1;
    return Promise.reject(error);
  }

  const { status } = errorResponse;
  const endpoint = error.request.responseURL;
  const recordingMsg = `${status}: ${endpoint}`;
  tagRecordings(['axios_error', recordingMsg]);
  if (status !== 401) {
    window.axiosActive -= 1;
    return Promise.reject(error);
  }
  const result = callToRefreshToken(error);
  window.axiosActive -= 1;
  return result;
});

export default ApiClient;
